// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"4684": "8b82e84d","494": "40775784","5856": "03084237",}[chunkId] + ".css"
}